import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getTalkingPointBrief = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/productivity-host/briefs/talking-points' });

  return data;
};

export default getTalkingPointBrief;
